import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { StopWorkService, StopWorkSource } from './stop-work.service';

@Component({
  selector: 'h3-stop-work-button',
  templateUrl: './stop-work-button.component.html',
  styleUrls: ['./stop-work-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StopWorkButtonComponent {
  private stopWorkService = inject(StopWorkService);

  stopWork(source: StopWorkSource) {
    this.stopWorkService.stopWork(source);
  }
}
